import { Component, EventEmitter, Input, Output } from "@angular/core";

export interface GenericButtonItem {
	showButton?: (item: unknown) => unknown;
	ariaLabel?: string;
	title: string;
	disabled: boolean;
	buttonCSS?: string;
	iconCSS?: string;
	isIconOnly: boolean;
}

@Component({
	selector: "stages-button",
	templateUrl: "./button.component.html",
})
export class ButtonComponent {
	@Input()
	buttonType: string = "button";

	@Input()
	ariaLabel?: string;

	@Input()
	title: string = "no title provided";

	@Input()
	doNotTranslate: boolean = false;

	@Input()
	disabled: boolean = false;

	@Input()
	buttonCSS: string = "button sm";

	@Input()
	iconCSS?: string;

	@Input()
	isIconOnly: boolean = false;

	@Input()
	showLoadingSpin: boolean = false;

	@Input()
	showAsPlainText: boolean = false;

	@Output()
	readonly clicked = new EventEmitter<boolean>();

	@Input()
	buttonTranslateParams?: { ARG0: string }; //aligned parameter name with parammeter name of menu component. Needed for split button components menu items

	getAriaLabel(): string {
		return this.ariaLabel ?? this.title;
	}
}
